// import { IndexPage } from 'components';

// export default IndexPage;
import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import Hero2 from "../components/Hero/Hero2";
//import About from '../components/About';
import About2 from "../components/About2";
import Postfestum from "../components/Postfestum";
import About2022 from "../components/About2022";
import Program from "../components/program/Program";
import Zbornik from "../components/Zbornik";
import Lokacija from "../components/Lokacija";
import Dates from "../components/Dates";
import Kotizacija from "../components/Kotizacija";
import Sponsors from "../components/Sponsors";
import Footer from "../components/Footer";
import Publikacije from "../components/Publikacije";

export default function IndexPage() {
  return (
    <>
      <Layout>
        <Helmet>
          <meta charSet="utf-8" />

          <title>Dnevi varstvoslovja 2022.</title>
          <meta name="title" content="Dnevi varstvoslovja 2022." />
          <meta
            name="description"
            content="Dnevi varstvoslovja so osrednja nacionalna konferenca s področja varnosti. Letošnja konferenca bo potekala 8. in 9. junija v Kongresnem centru Thermana Laško."
          />
          <link rel="canonical" href="https://www.fvv.um.si/DV2022" />

          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.fvv.um.si/DV2022/" />
          <meta property="og:title" content="Dnevi varstvoslovja 2022." />
          <meta
            property="og:description"
            content="Dnevi varstvoslovja so osrednja nacionalna konferenca s področja varnosti. Letošnja konferenca bo potekala 8. in 9. junija v Kongresnem centru Thermana Laško."
          />
          <meta
            property="og:image"
            content="https://www.fvv.um.si/DV2021/DV2021-social-image.jpg"
          />

          <meta property="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:url"
            content="https://www.fvv.um.si/DV2022/"
          />
          <meta property="twitter:title" content="Dnevi varstvoslovja 2022." />
          <meta
            property="twitter:description"
            content="Dnevi varstvoslovja so osrednja nacionalna konferenca s področja varnosti. Letošnja konferenca bo potekala 8. in 9. junija v Kongresnem centru Thermana Laško."
          />
          <meta
            property="twitter:image"
            content="https://www.fvv.um.si/DV2022/DV2022-social-image.png"
          ></meta>
          <link
            rel="icon"
            type="image/png"
            href="favicon-32x32.png"
            sizes="32x32"
          />
          <link
            rel="icon"
            type="image/png"
            href="favicon-16x16.png"
            sizes="16x16"
          />
        </Helmet>
        <Hero2 />
        <Postfestum />
        <About2 />
        <About2022 />
        {/* <Zbornik /> */}
        {/* <Program /> */}
        {/* <Lokacija />
        <Dates /> */}
        <Publikacije />
        {/* <Kotizacija /> */}
        <Sponsors />
        <Footer />
      </Layout>
    </>
  );
}
